import axios from 'axios';
import authService from './authService';
import { getCurrentBorerConfig } from '../config/borerEnvironmentConfig';

class BorerObservabilidadeService {
  async getMonitoramentosUltimosDias(dias = 3) {
    const token = await authService.getAccessToken();
    const { apiBaseUrl } = getCurrentBorerConfig();

    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - dias);

    try {
      const response = await axios.get(
        `${apiBaseUrl}/api/indirectmonitoring/date-range`,
        {
          params: {
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString(),
          },
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data.data;
    } catch (error) {
      if (error.response?.status === 401) {
        authService.clearToken();
      }
      throw error;
    }
  }

  async getAllProcessmentStatuses() {
    const token = await authService.getAccessToken();
    const { apiBaseUrl } = getCurrentBorerConfig();

    try {
      const response = await axios.get(
        `${apiBaseUrl}/api/indirectmonitoringprocessmentstatus`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const map = new Map();
      for (const s of response.data.data) {
        map.set(s.id, s);
      }
      return map;
    } catch (error) {
      if (error.response?.status === 401) {
        authService.clearToken();
      }
      throw error;
    }
  }

  async getHistoricoProcessamento(indirectMonitoringId) {
    const token = await authService.getAccessToken();
    const { apiBaseUrl } = getCurrentBorerConfig();

    try {
      const response = await axios.get(
        `${apiBaseUrl}/api/processment-historic/${indirectMonitoringId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        authService.clearToken();
      }
      throw error;
    }
  }

  async getCompanyById(companyId) {
    const token = await authService.getAccessToken();
    const { apiBaseUrl } = getCurrentBorerConfig();

    try {
      const response = await axios.get(
        `${apiBaseUrl}/api/companies/${companyId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data.data;
    } catch (error) {
      if (error.response?.status === 401) {
        authService.clearToken();
      }
      throw error;
    }
  }

  async getMonitoramentoById(id) {
    const token = await authService.getAccessToken();
    const { apiBaseUrl } = getCurrentBorerConfig();

    try {
      const response = await axios.get(
        `${apiBaseUrl}/api/indirectmonitoring/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data.data;
    } catch (error) {
      if (error.response?.status === 401) {
        authService.clearToken();
      }
      throw error;
    }
  }

  async getUltimosMonitoramentos(quantidade = 5) {
    const todos = await this.getMonitoramentosUltimosDias(30);
    const ordenado = [...todos].sort(
      (a, b) => new Date(b.collectDateTime) - new Date(a.collectDateTime)
    );
    return ordenado.slice(0, quantidade);
  }
}

export default new BorerObservabilidadeService();
